import {
    Button,
    Col,
    Divider,
    Grid,
    Heading,
    Message,
    Row,
    Stack,
    toaster,
} from "rsuite";
import * as React from "react";

import { v4 as uuidv4 } from "uuid";
import useAxiosPrivate from "app/hooks/useAxiosPrivate";
import { findDuplicateIds, hasInvalidIds, mergeArraysById } from "functions";
import { LoadingButton } from "@mui/lab";

import AgGrid from "app/components/AgGrid";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import SideDrawer from "app/components/SideDrawer";
import { Field, Formik } from "formik";
import { Autocomplete, TextField } from "@mui/material";
import { DateField, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import * as yup from "yup";
import useAPINew from "app/hooks/useAPINew";
import { Balance } from "@mui/icons-material";
import useAuth from "app/hooks/useAuth";
import { DELETE_PREMIUMPOINT, EDIT_PREMIUMPOINT } from "Permissions";
const validationSchema = yup.object({});
const columns1 = [
    { id: "ID", field: "ID", Width: 200, visible: true },
    { id: "InvoiceID", field: "InvoiceID", Width: 200 },
    { id: "Date", field: "Date", Width: 200 },
    { id: "NoOfTxn", field: "NoOfTxn", minWidth: 200 },
    { id: "NoOfCheque", field: "NoOfCheque", minWidth: 200 },
    { id: "NoOfPolicies", field: "NoOfPolicies", minWidth: 200 },
    { id: "TotalCash", field: "TotalCash", minWidth: 200 },
    { id: "TotalChequeAmnt", field: "TotalChequeAmnt", minWidth: 200 },
    { id: "TotalInvoiceAmnt", field: "TotalInvoiceAmnt", minWidth: 200 },
    { id: "ValidationID", field: "ValidationID", Width: 200 },
    { id: "PayDate", field: "PayDate", Width: 200 },
    { id: "MerchantID", field: "MerchantID", Width: 200 },
    { id: "CashierName", field: "CashierName", Width: 200, headerName: "Paid By AC" },
    { id: "Remark", field: "Remark", minWidth: 200 },
    { id: "UploadStatus", field: "UploadStatus", Width: 100 },
    { id: "Message", field: "Message", minWidth: 500 },
];

export default function ImportByPasteLICInvoice() {
    const { permissions, user } = useAuth();
    const [data, setData] = React.useState([]);
    const [status, setStatus] = React.useState(false);
    const PaymentByList = useAPINew("GetPaymentByList.php");
    const CashierList = useAPINew("GetCashierList.php");
    const axiosPrivate = useAxiosPrivate();
    const [initialValues, setInitialValues] = React.useState({
        Name: null,
        FUP: null,

        Health: null,
    });
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [selectedRowData, setSelectedRowData] = React.useState([]);
    const [filteredRows, setFilteredRows] = React.useState([]);

    async function GetDataByID1(ID) {
        try {
            const oldData = data.filter((a) => {
                return a.UniqueID === ID;
            });
            // console.log(oldData);
            if (oldData.length > 0) {
                console.log(oldData);
                let parts = oldData[0].PayDate.split("/");
                let formattedDateString = `${parts[2]}-${parts[1]}-${parts[0]}`;
                let parts2 = oldData[0].Date.split("-");
                let formattedDateString1 = `${parts2[2]}-${parts2[1]}-${parts2[0]}`;
                console.log(oldData);
                // Create a Date object
                let customDateObject = new Date(formattedDateString);
                let customDateObject1 = new Date(formattedDateString1);
                /*
                 InvoiceID: columns[1],
                    NoOfTxn: columns[3],
                    NoOfCheque: columns[4],
                    NoOfPolicies: columns[5],
                    TotalCash: columns[6].replace(",", ""),
                    TotalChequeAmnt: columns[7].replace(",", ""),
                    TotalInvoiceAmnt: columns[8].replace(",", ""),
                    ValidationID: columns[9],
                */
                const newData = {
                    UniqueID: oldData[0]?.UniqueID,
                    ID: oldData[0]?.ID,
                    CashierName: oldData[0]?.CashierName
                        ? { title: oldData[0]?.CashierName, value: oldData[0]?.CashierName }
                        : { title: "", value: "" },
                    InvoiceID: oldData[0]?.InvoiceID,
                    NoOfTxn: oldData[0]?.NoOfTxn,
                    NoOfCheque: oldData[0]?.NoOfCheque,
                    NoOfPolicies: oldData[0]?.NoOfPolicies,
                    TotalCash: oldData[0]?.TotalCash,
                    TotalChequeAmnt: oldData[0]?.TotalChequeAmnt,
                    TotalInvoiceAmnt: oldData[0]?.TotalInvoiceAmnt,
                    ValidationID: oldData[0]?.ValidationID,
                    PayDate: oldData[0]?.PayDate,
                    Date: oldData[0]?.Date,
                    MerchantID: oldData[0]?.MerchantID,
                    Remark: oldData[0]?.Remark,
                    PaymentBy: oldData[0]?.PaymentBy
                        ? { value: oldData[0]?.PaymentBy, title: oldData[0]?.PaymentBy }
                        : { value: "", title: "" },


                };
                console.log(newData);
                setInitialValues(newData);
            }
        } catch (error) {
            // console.log(error);
            toaster.push(
                <Message type="error" bordered showIcon>
                    <strong>Error!</strong> Error occured
                </Message>
            );
        }
    }

    const GetDataByID = React.useCallback(async (ID) => {
        try {
            const oldData = data.filter((a) => {
                return a.UniqueID === ID;
            });
            // console.log(oldData);
            if (oldData.length > 0) {
                let parts = oldData[0].FUP.split("/");
                let formattedDateString = `${parts[2]}-${parts[1]}-${parts[0]}`;

                // Create a Date object
                let customDateObject = new Date(formattedDateString);
                const newData = {
                    UniqueID: oldData[0]?.UniqueID,
                    ID: oldData[0]?.ID,
                    CashierName: oldData[0]?.CashierName
                        ? { title: oldData[0]?.CashierName, value: oldData[0]?.CashierName }
                        : { title: "", value: "" },
                    CDACharges: oldData[0]?.CDACharges,
                    CessAmt: oldData[0]?.CessAmt,
                    GSTAmt: oldData[0]?.GSTAmt,
                    Inst: oldData[0]?.Inst,
                    LateFee: oldData[0]?.LateFee,
                    LateFeeDiscount: oldData[0]?.LateFeeDiscount,
                    Name: oldData[0]?.Name,
                    PolicyNo: oldData[0]?.PolicyNo,
                    PremiumAmount: oldData[0]?.PremiumAmount,
                    ServiceBranch: oldData[0]?.ServiceBranch,
                    TotAmtDR: oldData[0]?.TotAmtDR,
                    XCharges: oldData[0]?.XCharges,
                    Cash: oldData[0]?.Cash,
                    Bank: oldData[0]?.Bank,
                    Balance: oldData[0]?.Balance,
                    Remark: oldData[0]?.Remark,
                    PaymentBy: oldData[0]?.PaymentBy
                        ? { value: oldData[0]?.PaymentBy, title: oldData[0]?.PaymentBy }
                        : { value: "", title: "" },

                    FUP:
                        oldData[0].FUP === "0000-00-00" || oldData[0].FUP === null
                            ? null
                            : customDateObject,
                };

                setInitialValues(newData);
            }
        } catch (error) {
            // console.log(error);
            toaster.push(
                <Message type="error" bordered showIcon>
                    <strong>Error!</strong> Error occured
                </Message>
            );
        }
    }, []);
    function updateDatainGrid(rawdata, ID) {
        const olddata = data.map((d) =>
            d.UniqueID === ID ? { ...d, ...rawdata } : d
        );
        setData(olddata);
    }
    React.useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed)
            if (selectedRowData?.UniqueID) {
                GetDataByID1(selectedRowData.UniqueID);
            }
        return () => {
            isSubscribed = false;
        };
    }, [selectedRowData?.UniqueID, selectedRowData]);

    const handlePaste = async (event) => {
        event.preventDefault();
        // Get the clipboard data
        const clipboardData = await window.navigator.clipboard.readText();
        console.log(clipboardData);
        const pastedData = clipboardData;

        // Parse the pasted data
        const parsedData = parseExcelData(pastedData);

        // Update the row data
        setData(parsedData);
    };

    /* 1	
    13925281
    30/03/2026	1	0	2	5,549.00	0.00	5,549.00	888819G 
    
    Sr. No.	Invoice ID	Date	No of Trns	No of Cheques	No of Policies	Total Cash Amt	
    Total Cheque Amt	Total Invoice Amt	Validation Id
    */

    const parseExcelData = (data) => {
        try {
            const lines = data
                .split("\n")
                .map(l => l.trim())
                .filter(l => l.length > 0);

            const result = [];

            // Process every 3 lines as one record
            for (let i = 0; i < lines.length; i += 3) {
                const id = lines[i];
                const invoiceId = lines[i + 1];
                const rest = lines[i + 2];

                if (!rest) continue;

                const columns = rest.split("\t").map(c => c.trim());

                if (columns.length < 8) {
                    console.warn("Invalid row:", rest);
                    continue;
                }

                // Date parsing
                const parts = columns[0].split("/");
                const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;

                result.push({
                    PayDate: moment().format("YYYY-MM-DD"),
                    CashierName: "",
                    MerchantID: "",
                    InvoiceID: invoiceId,
                    NoOfTxn: columns[1],
                    NoOfCheque: columns[2],
                    NoOfPolicies: columns[3],
                    TotalCash: columns[4].replace(/,/g, ""),
                    TotalChequeAmnt: columns[5].replace(/,/g, ""),
                    TotalInvoiceAmnt: columns[6].replace(/,/g, ""),
                    ValidationID: columns[7],
                    Date: moment(formattedDate).format("YYYY-MM-DD"),
                    UniqueID: uuidv4(),
                    ID: parseInt(id, 10),
                });
            }

            return result;

        } catch (error) {
            console.log(error);
        }
    };

    function onGridReady() { }
    const history = useNavigate();
    const location = useLocation();
    const updateQueryParams = React.useCallback(
        (activeKey) => {
            const params = new URLSearchParams(location.search);
            params.set("data", JSON.stringify(activeKey));
            history(`?${params.toString()}`, { replace: true });
        },
        [history, location.search]
    );

    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        const nameFromParams = params.get("data");

        if (nameFromParams) {
            setData(JSON.parse(nameFromParams));
        }
    }, [location.search]);

    async function handleImport() {
        setStatus(true);
        if (data.length > 0) {
            const duplicates = findDuplicateIds(data);
            if (hasInvalidIds(data)) {
                console.log("Invalid IDs found:");
                toaster.push(
                    <Message type="error" bordered showIcon>
                        <strong>Invalid IDs!</strong> {`There are some invalid IDs`}
                    </Message>
                );
                setStatus(false);
                return;
            } else if (duplicates.length > 0) {
                console.log("Duplicate IDs found:");
                toaster.push(
                    <Message type="error" bordered showIcon>
                        <strong>Duplicate IDs!</strong>{" "}
                        {`Duplicate IDs found - ${duplicates.toString()}`}
                    </Message>
                );
                setStatus(false);
                return;
            } else {
                try {
                    axiosPrivate
                        .post("ImportLICInvoiceData.php", {
                            data,
                        })
                        .then((response) => {
                            const result = response.data;
                            if (result.status === 1) {
                                toaster.push(
                                    <Message type="success" bordered showIcon>
                                        <strong>Success!</strong> {result.Success}
                                    </Message>
                                );
                                const newData = mergeArraysById(data, result.Data);
                                //console.log(newData);
                                setData(newData);
                                //updateQueryParams(newData);
                            }
                            if (result.status === 0) {
                                toaster.push(
                                    <Message type="error" bordered showIcon>
                                        <strong>Error!</strong> {result.Error}
                                    </Message>
                                );
                            }
                            setStatus(false);
                            // resetForm();
                        })
                        .catch((error) => {
                            console.error("Error submitting data:", error);
                            setStatus(false);
                        });
                } catch (error) {
                    console.error(error);
                    setStatus(false);
                }
            }
        } else {
            toaster.push(
                <Message type="error" bordered showIcon>
                    Please upload a file first
                </Message>
            );
            setStatus(false);
        }
    }

    return (
        <>
            <div
                style={{ width: "100%", border: "0.5px dashed #999", borderRadius: 10 }}
            >
                <Heading level={5} style={{ textAlign: "center" }}>
                    Import Invoice Data
                </Heading>
            </div>
            <div
                style={{
                    width: "100%",
                    margin: "10px 0px 10px 0px",
                    padding: 5,
                    border: "0.5px dashed #999",
                    borderRadius: 10,
                }}
            >
                <Stack direction="row" spacing={4}>
                    <Button onClick={handlePaste}>Paste</Button>

                    <LoadingButton
                        disabled={status}
                        type="submit"
                        color="secondary"
                        variant="contained"
                        onClick={handleImport}
                        loading={status}
                        sx={{ my: 2 }}
                    >
                        {status ? "Uploading..." : "Import"}
                    </LoadingButton>
                    <Button
                        onClick={() => {
                            setData([]);
                        }}
                    >
                        Clear
                    </Button>
                </Stack>
            </div>
            <div
                style={{
                    width: "100%",
                    minHeight: 600,
                    border: "0.5px dotted #999",
                    marginTop: 5,
                    borderRadius: 10,
                }}
            >
                <Grid fluid style={{ padding: 10 }}>
                    <Row className="show-grid">
                        <Col xs={24} sm={24} md={24}>
                            <Row className="show-grid" style={{ maxHeight: 350 }}>
                                <AgGrid
                                    onRowSelectedData={setSelectedRowData}
                                    handleViewModalOpen={handleOpen}
                                    settingsName="PastePremiumPoint"
                                    headerComponent={() => <p></p>}
                                    setFilteredRows={setFilteredRows}
                                    Source="PastePremiumPoint"
                                    exportAllowed={true}
                                    columns={columns1}
                                    rowData={data}
                                    onGridReady={onGridReady}
                                    defaultColumn={["Name"]}
                                    showHeaderItems={false}
                                    passdata={true}
                                />
                            </Row>
                        </Col>
                    </Row>
                </Grid>
            </div>
            <SideDrawer
                open={open}
                onClose={handleClose}
                title="Update Invoice Data"
            >
                <Formik
                    validationSchema={validationSchema}
                    initialValues={initialValues}
                    enableReinitialize={true}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        const newData = {
                            ...values,
                            MerchantID: values.MerchantID.value,
                            CashierName: values.CashierName.value,
                            PaymentBy: values.PaymentBy.value,
                            PayDate: moment(values.PayDate).format("YYYY-MM-DD"),
                            Date: moment(values.Date).format("YYYY-MM-DD"),
                        };
                        console.log(newData);
                        updateDatainGrid(newData, values.UniqueID);
                    }}
                >
                    {({
                        values,
                        errors,
                        setFieldValue,
                        handleSubmit,
                        isValidating,
                        isSubmitting,
                        touched,
                        handleBlur,
                        handleChange,
                    }) => {
                        // console.log(errors);
                        // console.log(values);
                        return (
                            <form>
                                <div>
                                    <div className="row">
                                        <Grid fluid style={{ padding: 4 }}>
                                            <Row className="show-grid">
                                                <Col xs={24} sm={24} md={24}>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            display: "flex",
                                                            alignItems: "flex-end",
                                                        }}
                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DateField
                                                                label="Date"
                                                                variant="standard"
                                                                size="small"
                                                                name="Date"
                                                                format="dd-MM-yyyy"
                                                                value={values.Date}
                                                                onChange={(value) =>
                                                                    setFieldValue("Date", value, true)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={touched.Date && Boolean(errors.Date)}
                                                                helperText={touched.Date && errors.Date}
                                                            />
                                                        </LocalizationProvider>
                                                    </Row>

                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            fullWidth
                                                            name={`InvoiceID`}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.InvoiceID),
                                                            }}
                                                            label="Invoice ID"
                                                            size="small"
                                                            as={TextField}
                                                            placeholder="Enter Invoice ID"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.InvoiceID && Boolean(errors.InvoiceID)
                                                            }
                                                            helperText={touched.InvoiceID && errors.InvoiceID}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            fullWidth
                                                            name={`ValidationID`}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.ValidationID),
                                                            }}
                                                            label="Validation ID"
                                                            size="small"
                                                            as={TextField}
                                                            placeholder="Enter Validation ID"
                                                            onBlur={handleBlur}
                                                            error={touched.ValidationID && Boolean(errors.ValidationID)}
                                                            helperText={touched.ValidationID && errors.ValidationID}
                                                        />
                                                    </Row>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            display: "flex",
                                                            alignItems: "flex-end",
                                                        }}
                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DateField
                                                                label="PayDate"
                                                                variant="standard"
                                                                size="small"
                                                                name="PayDate"
                                                                format="dd-MM-yyyy"
                                                                value={values.PayDate}
                                                                onChange={(value) =>
                                                                    setFieldValue("PayDate", value, true)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={touched.PayDate && Boolean(errors.PayDate)}
                                                                helperText={touched.PayDate && errors.PayDate}
                                                            />
                                                        </LocalizationProvider>
                                                    </Row>


                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`TotalCash`}
                                                            fullWidth
                                                            label="TotalCash"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.TotalCash),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Total Cash"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.TotalCash &&
                                                                Boolean(errors.TotalCash)
                                                            }
                                                            helperText={
                                                                touched.TotalCash && errors.TotalCash
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`TotalChequeAmnt`}
                                                            fullWidth
                                                            label="TotalChequeAmnt"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.TotalChequeAmnt),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Total Cheque Amount"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.TotalChequeAmnt &&
                                                                Boolean(errors.TotalChequeAmnt)
                                                            }
                                                            helperText={
                                                                touched.TotalChequeAmnt && errors.TotalChequeAmnt
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`TotalInvoiceAmnt`}
                                                            fullWidth
                                                            label="TotalInvoiceAmnt"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.TotalInvoiceAmnt),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Total Invoice Amount"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.TotalInvoiceAmnt &&
                                                                Boolean(errors.TotalInvoiceAmnt)
                                                            }
                                                            helperText={
                                                                touched.TotalInvoiceAmnt && errors.TotalInvoiceAmnt
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`NoOfTxn`}
                                                            fullWidth
                                                            label="NoOfTxn"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.NoOfTxn),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Number of Transactions"
                                                            onBlur={handleBlur}
                                                            error={touched.NoOfTxn && Boolean(errors.NoOfTxn)}
                                                            helperText={touched.NoOfTxn && errors.NoOfTxn}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`NoOfCheque`}
                                                            fullWidth
                                                            label="NoOfCheque"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.NoOfCheque),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Number of Cheques"
                                                            onBlur={handleBlur}
                                                            error={touched.NoOfCheque && Boolean(errors.NoOfCheque)}
                                                            helperText={touched.NoOfCheque && errors.NoOfCheque}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`NoOfPolicies`}
                                                            fullWidth
                                                            label="NoOfPolicies"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.NoOfPolicies),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Number of Policies"
                                                            onBlur={handleBlur}
                                                            error={touched.NoOfPolicies && Boolean(errors.NoOfPolicies)}
                                                            helperText={touched.NoOfPolicies && errors.NoOfPolicies}
                                                        />
                                                    </Row>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            marginLeft: -10,
                                                        }}
                                                    >
                                                        <Autocomplete
                                                            key="ID"
                                                            name={`MerchantID`}
                                                            options={
                                                                CashierList.error ? [null] : CashierList.data
                                                            }
                                                            getOptionLabel={(option) => option?.title}
                                                            disableClearable={true}
                                                            value={
                                                                Boolean(values.MerchantID)
                                                                    ? values.MerchantID
                                                                    : { value: "", title: "" }
                                                            }
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.MerchantID &&
                                                                Boolean(errors.MerchantID)
                                                            }
                                                            helperText={
                                                                touched.MerchantID && errors.MerchantID
                                                            }
                                                            onChange={(_, newValue) => {
                                                                console.log(values);
                                                                console.log(errors);
                                                                setFieldValue(`MerchantID`, newValue, true);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    name="MerchantID"
                                                                    onBlur={handleBlur}
                                                                    error={
                                                                        touched.MerchantID &&
                                                                        Boolean(errors.MerchantID)
                                                                    }
                                                                    helperText={
                                                                        touched.MerchantID && errors.MerchantID
                                                                    }
                                                                    label="Merchant ID"
                                                                    variant="standard"
                                                                />
                                                            )}
                                                            style={{ width: 200 }}
                                                        />
                                                    </Row>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            marginLeft: -10,
                                                        }}
                                                    >
                                                        <Autocomplete
                                                            key="ID"
                                                            name={`Payment By`}
                                                            options={
                                                                PaymentByList.error
                                                                    ? [null]
                                                                    : PaymentByList.data
                                                            }
                                                            getOptionLabel={(option) => option?.title}
                                                            disableClearable={true}
                                                            value={
                                                                Boolean(values.CashierName)
                                                                    ? values.CashierName
                                                                    : { value: "", title: "" }
                                                            }
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.CashierName && Boolean(errors.CashierName)
                                                            }
                                                            helperText={touched.CashierName && errors.CashierName}
                                                            onChange={(_, newValue) => {
                                                                console.log(values);
                                                                console.log(errors);
                                                                setFieldValue(`CashierName`, newValue, true);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    name="CashierName"
                                                                    onBlur={handleBlur}
                                                                    error={
                                                                        touched.CashierName &&
                                                                        Boolean(errors.CashierName)
                                                                    }
                                                                    helperText={
                                                                        touched.CashierName && errors.CashierName
                                                                    }
                                                                    label="Paid By Bank Account"
                                                                    variant="standard"
                                                                />
                                                            )}
                                                            style={{ width: 200 }}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`Remark`}
                                                            fullWidth
                                                            label="Remark"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.Remark),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Remark"
                                                            onBlur={handleBlur}
                                                            error={touched.Remark && Boolean(errors.Remark)}
                                                            helperText={touched.Remark && errors.Remark}
                                                        />
                                                    </Row>


                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                    <Divider />
                                    &nbsp; &nbsp;
                                    <>
                                        {(permissions.includes(EDIT_PREMIUMPOINT) ||
                                            user.Type === "SuperAdmin") && (
                                                <LoadingButton
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    color="secondary"
                                                    variant="contained"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleSubmit(e);
                                                    }}
                                                    loading={isValidating}
                                                    sx={{ my: 2 }}
                                                >
                                                    {isSubmitting ? "Submitting..." : "Submit"}
                                                </LoadingButton>
                                            )}

                                    </>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </SideDrawer>
        </>
    );
}
